import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { API_BASE_URL } from '../auth/api.config';

const REQUEST_ID_PATTERN = /^[A-Za-z0-9._-]{1,128}$/;

export const requestContextInterceptor: HttpInterceptorFn = (request, next) => {
  const apiBaseUrl = inject(API_BASE_URL);

  if (!sameOrigin(request.url, apiBaseUrl)) {
    return next(request);
  }

  const existing = request.headers.get('X-Request-ID');
  const requestId = existing && REQUEST_ID_PATTERN.test(existing) ? existing : createRequestId();

  return next(request.clone({ setHeaders: { 'X-Request-ID': requestId } }));
};

function sameOrigin(url: string, apiBaseUrl: string): boolean {
  try {
    return new URL(url).origin === new URL(apiBaseUrl).origin;
  } catch {
    return false;
  }
}

function createRequestId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return `nabd-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
}
